export enum PlaybackUpdatedSubType {
	INITIAL = 'Initial',
	FAILOVER = 'Failover',
	MANUAL_SWITCH = 'ManualSwitch',
	AUTO_SWITCH = 'AutoSwitch'
}
